import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getKhsBySemesterAndMhs = createAsyncThunk("khs/getKhsBySemesterAndMhs", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    //const response = await jwtAuthAxios.get(`v1/input/master/khs/mhs/all`);
    const response = await jwtAuthAxios.post(`v1/view/master/khs/mhs/param`,request);
    //const response = await jwtAuthAxios.post(`v1/input/master/khs/mhs/param`,request);
    return response.data;
});

export const getIpsIpk = createAsyncThunk("khs/getIpsIpk", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/indeks/prestasi/by_nim/${request}`);
    return response.data;
});

export const getLastIpsIpk = createAsyncThunk("khs/getLastIpsIpk", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/indeks/prestasi/last/by_nim/${request}`);
    return response.data;
});


export const getHistoryNilai = createAsyncThunk("khs/getHistoryNilai", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/history/nilai/by_nim/${request}`);
    return response.data;
});

export const postHistoryNilai = createAsyncThunk("khs/postHistoryNilai", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/history/nilai/by_nim`,request);
    return response.data;
});

export const getTranskipNilai = createAsyncThunk("khs/getTranskipNilai", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/mahasiswa/transkip/${request}`);
    return response.data;
});

const initialState = {
    loading: false,
    loadingIpsIpk: false,
    loadingHistoryNilai: false,
    dataKhs : [],
    dataIpsIpk : [],
    dataHistoryNilai : [],
    dataLastIpsIpk : {},
    dataTranskip: []
}

const khsSlice = createSlice({
    name:"khs",
    initialState: initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getKhsBySemesterAndMhs.pending, (state) => {
                state.loading = true;
            })
            .addCase(getKhsBySemesterAndMhs.fulfilled, (state, action) => {
                state.dataKhs = action.payload;
                state.loading = false;
            })
            .addCase(getKhsBySemesterAndMhs.rejected, (state, action) => {
                state.loading = false;
                console.error("Error during getMatkul:", action.error);
            })

            .addCase(getIpsIpk.pending, (state) => {
                state.loadingIpsIpk = true;
            })
            .addCase(getIpsIpk.fulfilled, (state, action) => {
                state.dataIpsIpk = action.payload;
                state.loadingIpsIpk = false;
            })
            .addCase(getIpsIpk.rejected, (state, action) => {
                state.loadingIpsIpk = false;
                console.error("Error during getMatkul:", action.error);
            })

            .addCase(getHistoryNilai.pending, (state) => {
                state.loadingHistoryNilai = true;
            })
            .addCase(getHistoryNilai.fulfilled, (state, action) => {
                state.dataHistoryNilai = action.payload;
                state.loadingHistoryNilai = false;
            })
            .addCase(getHistoryNilai.rejected, (state, action) => {
                state.loadingHistoryNilai = false;
                console.error("Error during getMatkul:", action.error);
            })

            .addCase(postHistoryNilai.pending, (state) => {
                state.loadingHistoryNilai = true;
            })
            .addCase(postHistoryNilai.fulfilled, (state, action) => {
                state.dataHistoryNilai = action.payload;
                state.loadingHistoryNilai = false;
            })
            .addCase(postHistoryNilai.rejected, (state, action) => {
                state.loadingHistoryNilai = false;
                console.error("Error during getMatkul:", action.error);
            })

            .addCase(getLastIpsIpk.pending, (state) => {
                state.loading = true;
            })
            .addCase(getLastIpsIpk.fulfilled, (state, action) => {
                state.dataLastIpsIpk = action.payload;
                state.loading = false;
            })
            .addCase(getLastIpsIpk.rejected, (state, action) => {
                state.loading = false;
            })

            .addCase(getTranskipNilai.pending, (state) => {
                state.loading = true;
            })
            .addCase(getTranskipNilai.fulfilled, (state, action) => {
                state.dataTranskip = action.payload;
                state.loading = false;
            })
            .addCase(getTranskipNilai.rejected, (state, action) => {
                state.loading = false;
            })
            
    }
})

export const khsSelectors = (state) => state.khs;
export default khsSlice.reducer;